/**
 * THE AVATAR BEING DRAWN, RIGHT NOW (§ F123, 2026-08-21).
 *
 * Jake: *"As I start drawing I want to see the avatar updated in the
 * top-right."* The header chip reads the SAVED profile (`fetchRoster`), which
 * is correct and is also one round trip behind a pen that is still moving. So
 * `/me` publishes each stroke here as it lands and the chip prefers it while it
 * exists — a preview, never storage: nothing in this module is persisted, and
 * it is cleared when the page that set it goes away.
 *
 * A module with a listener set rather than a context: the publisher and the
 * consumer are on opposite sides of the app tree (a page, and the chrome above
 * every page), and this is the same shape `lib/player.ts` already uses.
 */

import type { AvatarValue } from "./roster";

let draft: AvatarValue | null = null;
const listeners = new Set<() => void>();

/** Publish (or clear, with `null`) the avatar being drawn. */
export function setAvatarDraft(next: AvatarValue | null): void {
  draft = next;
  for (const listener of listeners) listener();
}

export function getAvatarDraft(): AvatarValue | null {
  return draft;
}

export function subscribeAvatarDraft(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}
